import * as React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { getImgPath } from '../store/StringTool';
import { useSelector, useDispatch } from 'react-redux';
import { settingActions, settingObj } from '../store/SettingSlice';
import HeroJson from '../store/hero.json';


export default function CharacterAllPage() {

    const dispatch = useDispatch();
    const settingData = useSelector(state => state.settingData);
    const ary = ['Ryu', 'Ken', 'E.Honda', 'Ibuki', 'Makoto', 'Dudley', 'Gen', 'Dan', 'Juri', 'Chun-Li',
        'Dhalsim', 'Abel', 'C.Viper', 'Vega', 'Cammy', 'Dee-Jay', 'Cody', 'Guy', 'Guile', 'Blanka',
        'Zangief', 'Rufus', 'Feilong', 'T.Hawk', 'Adon', 'Rose', 'Decapre', 'Yun', 'Sakura', 'Yang',
        'Hakan', 'Elena', 'Rolento', 'Hugo', 'Poison'];

    function backTap() {
        dispatch(settingActions.setCharacterWrapperIndex(0));
        dispatch(settingActions.setMousewheel(true))
    }

    return (
        <Stack sx={{
            bgcolor: 'black',
            width: 1,
            minHeight: window.innerHeight,
            alignItems: 'center',
        }}>
            <Box
                component={'img'}
                src={getImgPath('part5/skin_orange.jpg')}
                sx={{
                    position: 'absolute',
                    width: 1,
                    height: 1,
                    zIndex: 2,
                    objectFit: 'fill',
                }} />


            {/* 导航 */}
            <Stack sx={{
                position: 'absolute',
                height: '110px',
                width: 1,
                top: '90px',
                zIndex: 2,
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
            }}>

                <Box sx={{
                    width: 1,
                    height: '1px',
                    bgcolor: '#4B1515',
                    bottom: 0,
                    position: 'absolute',
                    zIndex: 3,
                }} />

                <Box
                    onClick={backTap}
                    component={'img'}
                    src={getImgPath('ico_back.png')}
                    sx={{
                        WebkitFilter: 'brightness(80%)',
                        filter: 'brightness(80%)',
                        width: '55px',
                        height: '55px',
                        transitionDuration: '0.3s',
                        cursor: 'pointer',
                        '&:hover': {
                            WebkitFilter: 'brightness(120%)',
                            filter: 'brightness(120%)',
                        },
                    }} />


                <Typography sx={{
                    color: '#B32228',
                    ml: 2,
                    fontSize: 30,
                    fontWeight: 'bold',
                    mr: 50,
                }}>
                    {settingData.langDic['menu4']}
                </Typography>

                <MenuItem type='type_all' />
                <MenuItem type='type_0' />
                <MenuItem type='type_1' />
                <MenuItem type='type_2' />
                <MenuItem type='type_3' />
                <MenuItem type='type_4' />
                <MenuItem type='type_5' />
            </Stack>

            <Stack
                onMouseOver={() => {
                    dispatch(settingActions.setMousewheel(false))
                }}
                onMouseLeave={() => {
                    dispatch(settingActions.setMousewheel(true))
                }}
                sx={{
                    minWidth: '800px',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 5,
                    position: 'absolute',
                    px: '100px',
                    top: '210px',
                    height: `${window.innerHeight - 210}px`,
                    overflowY: 'scroll',
                }}>

                {ary.map((value, i) => {
                    return <RoleItem key={i} name={value} />
                })}
            </Stack>
        </Stack>
    );
}

function RoleItem(props) {

    const dispatch = useDispatch();
    const settingData = useSelector(state => state.settingData);

    function tap() {
        dispatch(settingActions.setDetailName(props.name));
        dispatch(settingActions.setCharacterWrapperIndex(2));
        dispatch(settingActions.setMousewheel(true));
    }

    return (
        <Stack
            onClick={tap}
            sx={{
                width: '130px',
                height: '210px',
                mx: '5px',
                my: 1.3,
                transform: 'skew(-20deg)',
                overflow: 'hidden',
                border: 2,
                bgcolor: '#00000099',
                borderColor: settingData.type == HeroJson[props.name]['type'] ? 'white' : '#8E999E',
                transitionDuration: '0.3s',
                '&:hover': {
                    borderColor: '#D92D32',
                },
            }}>
            <Box
                component={'img'}
                src={getImgPath(`all/${props.name}.png`)}
                sx={{
                    WebkitFilter: settingData.type == HeroJson[props.name]['type'] ? 'brightness(120%)' : 'brightness(50%)',
                    filter: settingData.type == HeroJson[props.name]['type'] ? 'brightness(120%)' : 'brightness(50%)',
                    cursor: 'pointer',
                    transform: 'skew(20deg)',
                    width: '210px',
                    height: 1,
                    ml: '-40px',
                    overflow: 'hidden',
                    transitionDuration: '0.3s',
                    objectFit: 'contain',
                    '&:hover': {
                        WebkitFilter: 'brightness(120%)',
                        filter: 'brightness(120%)',
                    },
                }} />

            <Typography sx={{
                transform: 'skew(20deg)',
                position: 'absolute',
                bottom: 0,
                color: '#999999',
                backgroundSize: '100% 100%',
                fontSize: 12,
                width: 0.8,
                left: '-5px',
                pl: 3,
                fontWeight: 'bold',
                zIndex: 99,
                backgroundImage: `url(${getImgPath('part5/i_icon_namebg.png')})`,
            }}>
                {HeroJson[props.name][settingData.lang]['name'].toUpperCase()}
            </Typography>

        </Stack>
    );

}

function MenuItem(props) {
    const dispatch = useDispatch();
    const settingData = useSelector(state => state.settingData);

    function tap() {
        dispatch(settingActions.setType(props.type));
    }

    return (
        <Stack
            onClick={tap}
            sx={{
                mx: 1,
                transform: 'skew(-18deg)',
                width: '80px',
                height: '100px',
                position: 'relative',
                borderBottom: 2,
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                borderColor: props.type == settingData.type ? '#D92D32' : '',
                background: props.type == settingData.type ? 'linear-gradient(#1B0809 , #6B191C)' : 'linear-gradient(#310E0F , #22090A)',
                transitionDuration: '0.3s',
                '&:hover': {
                    background: 'linear-gradient(#1B0809 , #6B191C)',
                },
            }}>

            <Box
                component={'img'}
                src={getImgPath(`type/${props.type}.png`)}
                sx={{
                    transform: 'skew(18deg)',
                    width: '55px',
                    height: '55px',
                }} />

        </Stack>
    );

}